export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-save-0893e9b63d176c18679678bc8c0574a5.svg";